const URLASSOLUTO = window.URLASSOLUTO;
const URLASSOLUTOISTITUZIONALE = window.URLASSOLUTOISTITUZIONALE;
const TEMPLATEID = window.TEMPLATEID;
const CURRENTROUTENAME = window.CURRENTROUTENAME;
const VIEWNAME = window.VIEWNAME;
const PRODUCTID = window.PRODUCTID;
const APPLICATIONID = window.APPLICATIONID;
delete window.URLASSOLUTO;
delete window.URLASSOLUTOISTITUZIONALE;
delete window.CURRENTROUTENAME;
delete window.TEMPLATEID;
delete window.PRODUCTID;
delete window.APPLICATIONID;
delete window.VIEWNAME;
delete window.METATEMPLATEALTERNATE;

export { URLASSOLUTO, URLASSOLUTOISTITUZIONALE, CURRENTROUTENAME, VIEWNAME, TEMPLATEID, PRODUCTID, APPLICATIONID };
